import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { LinkButton } from "@repo/ui/link-button";
import { cn } from "@repo/ui/utils";
interface LoadMoreButtonProps {
  /** Click handler — typically the `loadMore` callback from `useListingState`. */
  onClick: () => void;
  /**
   * `true` while a fetch is in flight. Disables the button and swaps the
   * label to the loading variant.
   */
  isPending: boolean;
  /** Additional CSS class names merged onto the centring wrapper. */
  className?: string;
}

/**
 * "Load more" pagination button shared by directory listings. Lives at
 * the bottom of the grid; horizontally centred with desktop top margin.
 * Reads its labels from the `directory` translation namespace, so all
 * listings see consistent copy.
 */
export function LoadMoreButton(t0) {
  const $ = _c(12);
  const {
    onClick,
    isPending,
    className
  } = t0;
  const t = useTranslations("directory");
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex justify-center desktop:mt-8", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isPending || $[3] !== t) {
    t2 = isPending ? t("loadingMore") : t("loadMore");
    $[2] = isPending;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isPending || $[6] !== onClick || $[7] !== t2) {
    t3 = <LinkButton variant="primary" size="md" underline={true} onClick={onClick} disabled={isPending}>{t2}</LinkButton>;
    $[5] = isPending;
    $[6] = onClick;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t3) {
    t4 = <div className={t1}>{t3}</div>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}